module.exports = __webpack_public_path__ + "static/media/close-black.117c92e1.svg";